/**
 *
 * UserRoleManagement Routes
 *
 * Please note: routes need to be added in main routes file at src/modules/routes.js
 * or src/{mobileApp/webApp}/routes.js depending on current file location
 */

import { UserRoleManagementMenuRoutes } from 'modules/UserRoleManagement/UserRoleManagementConfig';
import { Navigate } from 'react-router-dom';
import { lazyLoad } from 'utils/loadable';

export const lazyUserRoleManagementPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'UserRoleManagementPage', webpackPrefetch: true */ './index'
    ),
  module => module.default,
);

export const UserRoleManagementPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'UserRoleManagementPage', webpackPrefetch: true */ './components/UserRoleManagementPage'
    ),
  module => module.default,
);

export const userRoleManagementMenuRoutes = allowAdminRoutes => [
  ...(allowAdminRoutes
    ? [
        {
          component: UserRoleManagementPage,
          path: UserRoleManagementMenuRoutes.USER_ROLE_MANAGEMENT,
          title: 'UserRoleManagement',
          needsAuth: true,
        },
      ]
    : []),
];

// routes declaration
export const userRoleManagementRoutes = [
  {
    component: Navigate,
    path: '/user-role',
    replace: true,
    to: '/user-role' + UserRoleManagementMenuRoutes.DEFAULT,
    toAdmin: '/user-role' + UserRoleManagementMenuRoutes.DEFAULT,
    needsAuth: true,
  },
  {
    component: lazyUserRoleManagementPage,
    title: 'User Role Management',
    path: '/user-role/*',
    needsAuth: true,
  },
];
